module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAGFBMVEUAAAD///////////////////////////8jfp1fAAAACHRSTlMAgP9XBa4ErXk1mk0AAAB1SURBVHja7Zi5DYBAEMSY4YD+O0aiAh45OGEXYAerTWYRERF5QQL728B+tJBeBPSjhbVlC2OzYMGCBQsWLFi4X+gHQgcaOtDQgWb2QKY8Mvtq+zG3f+jXr1+//n/6N/23/fQoyM+aaCH8tIwWgs/7IiIizzkB4goJxarzEu8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/right-white.png
// module id = hVf9
// module chunks = 0